export default "__VITE_ASSET__Boob3b85__"